import { useEffect, useRef } from 'react';

const takeaways = [
  'Clareza para tomar decisões com confiança e sem ansiedade.',
  'Novas perspectivas sobre planejamento que vão além do Pinterest.',
  'Conexões valiosas com profissionais que realmente entendem você.',
  'Inspirações aplicáveis — nada de ideias impossíveis de executar.',
  'Experiências exclusivas que você não encontra em lugar nenhum.',
  'Materiais desenvolvidos para acompanhar cada etapa da sua jornada.',
  'Memórias que vão durar muito além do grande dia.',
];

export default function TakeHomeSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-on-scroll').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="leva-para-casa" className="relative py-24 md:py-36 px-6 md:px-10 overflow-hidden" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 30% 50%, oklch(var(--primary-500)) 0%, transparent 50%), radial-gradient(circle at 70% 30%, oklch(var(--accent-500)) 0%, transparent 40%)',
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Column - Image */}
          <div className="reveal-on-scroll relative order-2 lg:order-1">
            <div className="overflow-hidden rounded-lg w-full" style={{ aspectRatio: '3/4' }}>
              <img
                src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/60e0bb0de20db41932a091837d31a6ef.jpeg"
                alt="Noiva elegante com kit de experiência curado"
                title="O que você leva - The Future Wedding Ribeirão Preto"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column - Checklist */}
          <div className="reveal-on-scroll order-1 lg:order-2">
            <p className="text-xs tracking-[0.25em] uppercase mb-6" style={{ color: 'oklch(var(--secondary-500))' }}>
              O Resultado
            </p>

            <h2
              className="font-heading text-3xl md:text-4xl lg:text-5xl leading-[1.15] mb-6"
              style={{ color: 'oklch(var(--foreground-900))' }}
            >
              O que você leva
              <br />
              para casa
            </h2>

            <p className="text-sm md:text-base leading-relaxed mb-10" style={{ color: 'oklch(var(--foreground-500))' }}>
              Muito além de um evento. Uma bagagem de clareza, conexões e
              inspirações que transformam a sua jornada.
            </p>

            <ul className="space-y-5">
              {takeaways.map((item, index) => (
                <li key={index} className="reveal-on-scroll flex items-start gap-4" style={{ transitionDelay: `${index * 0.08}s` }}>
                  <div
                    className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 transition-all duration-500"
                    style={{ backgroundColor: 'oklch(var(--primary-100))' }}
                  >
                    <i className="ri-check-line text-sm" style={{ color: 'oklch(var(--primary-500))' }}></i>
                  </div>
                  <span className="text-sm md:text-base leading-relaxed" style={{ color: 'oklch(var(--foreground-700))' }}>
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}